<div id="content" class="extensible">
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
  <div id="page-header">
    <div class="page-title">
      <span>{{ company_product_title }}</span>
      <h1>{{ title }}</h1>
    </div>

    <nav mat-tab-nav-bar [tabPanel]="tabPanel">
      @for (link of navLinks; track link) {
        <a
          mat-tab-link
          [routerLink]="link.link"
          routerLinkActive
          #rla="routerLinkActive"
          [active]="rla.isActive"
          [queryParams]="navLinks[activeLinkIndex] && navLinks[activeLinkIndex].queryParamGroup === link.queryParamGroup ? queryParams : {}"
        >
          {{ link.label }}
        </a>
      }
    </nav>

    <div style="text-align: right">
      <button mat-flat-button [routerLink]="['../../phases']">
        <mat-icon>arrow_back</mat-icon>
        Volver al producto
      </button>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
